<template>
  <div
    :class="[
      'adaptive-nav-link',
      { active: isActive },
      isMini ? 'mini' : 'full',
      isHeader ? 'header' : 'link']"
  >
    <div class="name">
      <!-- Feature is not available to this advisor -->
      <div v-if="!isEnabled">
        <DisabledNavLink
          :display-name="displayName"
          :feature-name="link?.feature"
        />
      </div>

      <!-- Use Vue router if available -->
      <router-link
        v-else-if="hasRouter && useRouter"
        :to="href"
      >
        {{ displayName }}
      </router-link>

      <!-- Fallback to regular link -->
      <a
        v-else-if="href"
        :href="href"
      >{{ displayName }}</a>

      <!-- Section header with no link -->
      <span
        v-else
        class="pointer"
        @click="$emit('toggle')"
      >
        {{ displayName }}
      </span>
    </div>

    <!-- Icon-->
    <div
      v-if="hasLinks"
      class="pointer"
      @click="$emit('toggle')"
    >
      <i class="fa fa-chevron-down" />
    </div>
  </div>
</template>


<script>
// import SubComponent from '../components/SubComponent'
import DisabledNavLink from './DisabledNavLink.vue';

export default {
  name: 'ComponentName',
  components: { DisabledNavLink },
  props: ['name', 'link', 'active', 'isMini', 'hasLinks', 'features'],
  data() {
    return { /* Local variables */ };
  },
  computed: { /*
    Creates a new property
    Updates when any dependant property changes */
    displayName() {
      return this.name || this.link.name;
    },
    isHeader() {
      return !!this.name;
    },
    isActive() {
      if (!this.active) return false;
      return this.displayName === this.active.name;
    },
    href() {
      const path = this.wrap(this.link?.path);
      return this.useRouter && !this.hasRouter ? '/ui' + path : path;
    },
    isEnabled() {
      const feature = this.link?.feature;
      if (!feature) return true;
      if (!this.features) return false;
      return this.features[feature];
    },
    hasRouter() {
      return this.$router ? true : false;
    },
    useRouter() {
      return this.link?.useRouter ? true : false;
    },
  },
  watch: { /*
    Watches an existing property
    Only runs when the watched property changes */
  },
  beforeCreate() {},
  created() {},
  mounted() {

  },
  updated() {},
  methods: {
    wrap(path) {
      return path ? '/' + path + '/' : '';
    },
  },
};
</script>


<style scoped>
  .adaptive-nav-link {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.1em 0.5em 0.1em 0.5em;
    transition: background-color 0.25s;
  }

  .full {
    border-radius: 0.2em;
  }

  .full:hover, .mini.link:hover {
    background-color: #cdd6e4;
    color: black;
  }

  .name {
    display: flex;
    flex-grow: 1;
    white-space: nowrap;
  }

  .name > * {
    flex-grow: 1;
    padding-right: 1em;
  }

  .active.header.full,
  .active.header.full a,
  .active.link {
    background-color: #3a66ac;
    color: white;
  }

  .header {
    font-size: 18px;
    font-weight: bold;
  }

  .pointer:hover {
    cursor: pointer;
  }

  a {
    color: inherit;
  }
</style>
